import { INewsResponse } from '@/@types/News';
import { api } from './api';

async function getActiveNews() {
  const response = await api.get<INewsResponse>('/v1/news/active');
  return response?.data?.data ?? [];
}

export const NewsService = { getActiveNews };
